(() => {
  'use strict';
  const root = document.querySelector('#demo-main');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const catalog = JSON.parse(document.querySelector('#cb-demo-catalog').textContent);
  const products = new Map(catalog.map(product => [product.id, product]));
  const brands = [...document.querySelectorAll('[data-brand]')];
  const overview = document.querySelector('[data-overview]');
  const productDialog = document.querySelector('#demo-product-dialog');
  const cartDialog = document.querySelector('#demo-cart-dialog');
  const cartItems = document.querySelector('#demo-cart-items');
  const status = document.querySelector('#demo-status');
  const money = value => '¥' + value.toLocaleString('ja-JP');
  const carts = new Map(brands.map(brand => [brand.dataset.brand, []]));
  let currentBrand = 'all';
  let currentProduct = null;
  let lastTrigger = null;

  function announce(message) {
    status.textContent = message;
    document.querySelector('#demo-cart-status').textContent = message;
  }

  function route(focus = false) {
    const hash = location.hash.slice(1);
    if (hash === 'demo-main') {
      if (focus) root.focus({ preventScroll: true });
      return;
    }
    const requested = hash.startsWith('products-') ? hash.slice(9) : hash;
    const active = brands.find(brand => brand.dataset.brand === requested);
    currentBrand = active ? requested : 'all';
    overview.hidden = Boolean(active);
    brands.forEach(brand => { brand.hidden = brand !== active; });
    document.querySelectorAll('[data-brand-link]').forEach(link => {
      if (link.dataset.brandLink === currentBrand) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
    const name = active?.querySelector('.demo-wordmark').textContent || '閲覧用デモ集';
    document.title = name + ' | 閲覧用デモ | Cross Bridge';
    updateCount();
    if (focus && !hash.startsWith('products-')) {
      productDialog.close(); cartDialog.close();
      root.focus({ preventScroll: true });
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
    if (hash.startsWith('products-')) document.getElementById(hash)?.scrollIntoView();
  }

  function updateCount() {
    brands.forEach(brand => {
      const count = carts.get(brand.dataset.brand).reduce((sum, line) => sum + line.quantity, 0);
      brand.querySelector('[data-cart-count]').textContent = count;
    });
  }

  function openProduct(id, trigger) {
    const product = products.get(id);
    if (!product || product.brand !== currentBrand) return;
    currentProduct = product; lastTrigger = trigger;
    const image = document.querySelector('#demo-product-image');
    image.src = product.image; image.alt = product.name + 'のデモ用画像';
    document.querySelector('#demo-product-title').textContent = product.name;
    document.querySelector('#demo-product-price').textContent = money(product.price) + '（参考価格）';
    document.querySelector('#demo-product-description').textContent = product.description;
    document.querySelector('#demo-option').replaceChildren(...product.options.map(label => new Option(label, label)));
    document.querySelector('#demo-quantity').value = '1';
    productDialog.showModal(); productDialog.scrollTop = 0;
  }

  function element(tag, className, content) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined) node.textContent = content;
    return node;
  }

  function renderCart() {
    const lines = carts.get(currentBrand) || [];
    const content = lines.map((line, index) => {
      const product = products.get(line.id);
      const item = element('article', 'demo-cart-line');
      const image = element('img');
      image.src = product.image; image.alt = product.name; image.width = 88; image.height = 88;
      const copy = element('div', 'demo-cart-line-copy');
      copy.append(element('h3', '', product.name), element('p', '', line.option), element('p', '', money(product.price) + ' / 参考価格'));
      const controls = element('div', 'demo-cart-line-controls');
      const label = element('label', '', '数量');
      const select = element('select');
      select.setAttribute('aria-label', product.name + 'の数量'); select.dataset.cartQuantity = index;
      for (let quantity = 1; quantity <= 9; quantity++) select.add(new Option(String(quantity), String(quantity)));
      select.value = String(line.quantity); label.append(select);
      const remove = element('button', '', '削除');
      remove.type = 'button'; remove.dataset.cartRemove = index;
      remove.setAttribute('aria-label', product.name + 'をデモカートから削除');
      controls.append(label, remove); copy.append(controls); item.append(image, copy);
      return item;
    });
    cartItems.replaceChildren(...(content.length ? content : [element('p', 'demo-empty', 'カートは空です。気になる商品を選んで、カート追加を体験してください。')]));
    document.querySelector('#demo-cart-total').textContent = money(lines.reduce((sum, line) => sum + products.get(line.id).price * line.quantity, 0));
    updateCount();
  }

  document.addEventListener('click', event => {
    const product = event.target.closest('[data-product]');
    if (product) openProduct(product.dataset.product, product);
    const cart = event.target.closest('[data-cart-open]');
    if (cart) { lastTrigger = cart; renderCart(); cartDialog.showModal(); }
    const close = event.target.closest('[data-close]');
    if (close) close.closest('dialog').close();
    const filter = event.target.closest('[data-filter]');
    if (filter) {
      const brand = filter.closest('[data-brand]');
      brand.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
      let count = 0;
      brand.querySelectorAll('.demo-product').forEach(card => {
        card.hidden = filter.dataset.filter !== 'all' && card.dataset.category !== filter.dataset.filter;
        if (!card.hidden) count++;
      });
      brand.querySelector('[data-results]').textContent = count + '件';
    }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      const index = Number(remove.dataset.cartRemove);
      carts.get(currentBrand).splice(index, 1); renderCart();
      announce('デモカートから商品を削除しました。');
      (cartItems.querySelector('button') || cartDialog.querySelector('[data-close]')).focus();
    }
  });

  document.addEventListener('change', event => {
    if (event.target.matches('[data-sort]')) {
      const grid = event.target.closest('[data-brand]').querySelector('.demo-product-grid');
      const value = event.target.value;
      const cards = [...grid.children].sort((a, b) => value === 'default' ? Number(a.dataset.order) - Number(b.dataset.order) : (Number(a.dataset.price) - Number(b.dataset.price)) * (value === 'high' ? -1 : 1));
      grid.append(...cards);
    }
    if (event.target.matches('[data-cart-quantity]')) {
      const index = Number(event.target.dataset.cartQuantity);
      carts.get(currentBrand)[index].quantity = Number(event.target.value);
      // Preserve focus by updating the total and count without rebuilding the row.
      const lines = carts.get(currentBrand);
      document.querySelector('#demo-cart-total').textContent = money(lines.reduce((sum, line) => sum + products.get(line.id).price * line.quantity, 0));
      updateCount(); announce('数量を変更しました。');
    }
  });

  document.querySelector('#demo-add-form').addEventListener('submit', event => {
    event.preventDefault();
    if (!currentProduct) return;
    const option = document.querySelector('#demo-option').value;
    const quantity = Number(document.querySelector('#demo-quantity').value);
    const lines = carts.get(currentBrand);
    const existing = lines.find(line => line.id === currentProduct.id && line.option === option);
    if (existing) existing.quantity = Math.min(9, existing.quantity + quantity);
    else lines.push({ id: currentProduct.id, option, quantity });
    productDialog.close(); renderCart(); cartDialog.showModal();
    announce(currentProduct.name + 'をデモカートに追加しました。');
  });

  for (const dialog of [productDialog, cartDialog]) {
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (!productDialog.open && !cartDialog.open && lastTrigger?.isConnected) lastTrigger.focus({ preventScroll: true });
    });
  }
  window.addEventListener('hashchange', () => route(true));
  route();
})();
